import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PopupMessageComponent, PopupStatus } from "common";
import { NotificationOptions } from "../interfaces/notification.interface";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  snackbar = inject(MatSnackBar);

  showNotification(options?: NotificationOptions): void {
    const { header = 'Success!', message = '', status = PopupStatus.Information } = options;

    this.snackbar.openFromComponent(PopupMessageComponent, {
      data: { header, message, status },
      duration: 2500,
    });
  }
}
